import contactName from "../utils/contactName";

export default {
  data() {
    return {
      updateTitleTryTimeOut: undefined,
    };
  },
  computed: {
    chatCountMessageNew() {
      return this.$store.state.rooms.counters.all.all || 0;
    },
  },
  watch: {
    '$store.state.rooms.selectedRoomId'() {
      this.updateTitleTry();
    },
    '$store.state.rooms.counters'() {
      this.updateTitleTry();
    },
    '$store.state.rooms.counters.all.all'() {
      this.updateTitleTry();
    },
  },
  mounted() {
    this.updateTitleTry();
  },
  methods: {
    updateTitleTry() {
      try {
        this.updateTitle();
      } catch (e) {
        this.updateTitleTryTimeOut && clearTimeout(this.updateTitleTryTimeOut);
        this.updateTitleTryTimeOut = setTimeout(this.updateTitleTry, 50);
      }
    },
    updateTitle() {
      let title = '';

      if (this.chatCountMessageNew) {
        title += '(' + this.chatCountMessageNew + ') ';
      }

      if (this.$store.state.rooms.selectedRoomId) {
        const room = this.$store.state.rooms.rooms[this.$store.state.rooms.selectedRoomId];
        title += contactName(room) + ' - ' + room.clientsender.name;
      }

      window.document.title = (title || 'Chats') + ' | Messaggio Chat';
    },
  },
};
